import { render, staticRenderFns } from "./adminTabParkDelete.vue?vue&type=template&id=458a9d88&scoped=true&"
import script from "./adminTabParkDelete.vue?vue&type=script&lang=ts&"
export * from "./adminTabParkDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a9d88",
  null
  
)

export default component.exports